
import { computed, defineComponent, PropType } from "vue";

import {
  FormFieldComboBox,
  FormField,
  BaseButton,
  SouthIcon,
  DeleteIcon,
  NorthIcon,
  FormFieldMultiSelect,
} from "@tager/admin-ui";

import {
  ConditionFormValue,
  operatorOptionList,
  typeConditionOptionList,
} from "@/views/CategoryForm/CategoryForm.helpers";
import { moveItem } from "@/views/BasisProductForm/BasisProductForm.helpers";
import FieldConditionTable from "@/views/CategoryForm/components/FieldConditionTable";

type Props = Readonly<{ conditions: Array<ConditionFormValue> }>;

export default defineComponent({
  name: "ConditionsComponent",
  components: {
    FieldConditionTable,
    FormFieldComboBox,
    FormField,
    FormFieldMultiSelect,
    BaseButton,
    SouthIcon,
    DeleteIcon,
    NorthIcon,
  },
  props: {
    conditions: {
      type: Array as PropType<Props["conditions"]>,
      required: true,
    },
    productTypeOptionList: {
      type: Array,
      required: true,
    },
    brandListOption: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const filteredTypeConditionOptionList = computed(() =>
      props.conditions.some((condition) => condition.type?.value === "BRAND")
        ? typeConditionOptionList?.filter(
            (typeConditionOption) => typeConditionOption.value !== "BRAND"
          )
        : typeConditionOptionList
    );

    function removeField(rowIndex: number) {
      props.conditions.splice(rowIndex, 1);
    }

    function handleClick(
      itemList: Array<ConditionFormValue>,
      itemIndex: number,
      direction: "up" | "down"
    ) {
      moveItem<ConditionFormValue>(itemList, itemIndex, direction);
    }

    return {
      typeConditionOptionList,
      filteredTypeConditionOptionList,
      operatorOptionList,
      removeField,
      handleClick,
    };
  },
});
